// extracted by mini-css-extract-plugin
module.exports = {"loader":"loader_loader__YazJ9","spin":"loader_spin__iJMW3","center":"loader_center__2TEyh"};